import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import styles from "./paymentlist.module.css";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Check, CreditCard } from "react-feather";
import dayjs from "dayjs";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";

const RecordPayment = ({ item, index, taskExpanded, handleChange, setLoading, setSnackbarOpen, setSnackbarMsg, setAddPaymentModalShow, setIsUpdate, setEditId, setDeleteModalShow, setDeleteId, setDeleteType }) => {
    const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();

    const resendReceipt = async () => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.get(process.env.REACT_APP_PAYMENT_API_URL + "v1/resend-receipt/" + item?.id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);
            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<Accordion key={index} expanded={taskExpanded === "panel" + index} onChange={handleChange("panel" + index)}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
            <div className={`${styles.NotesCard}`}>
                <div className={`${styles.RentRollDateSec} ${styles.Green}`}>
                    <div className={`${styles.RentRollDate}`}>{dayjs(item?.date).format('MMM D')}</div>
                    <div className={`${styles.RentRollYear}`}>{dayjs(item?.date).format('YYYY')}</div>
                </div>
                <div className={`${styles.RentRollDesc} ${styles.Green}`}>
                    <div className={`${styles.Top}`}>
                        <div className={`${styles.Badge}`}><CreditCard /></div>
                        <div className={`${styles.Title}`}>{item?.description}</div>
                    </div>
                    <div className={`${styles.SubText}`}>Payment Sent</div>
                </div>
                <div className={`${styles.RentRollDue}`}>
                    <div className={`${styles.DueEmpty}`}>—</div>
                </div>
                <div className={`${styles.RentRollPayment}`}>
                    <div className={`${styles.PaymentOk}`}>
                        <div className={`${styles.Label}`}><Check /> Applied</div>
                        <div className={`${styles.Amount}`}>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(item?.amount)}</div>
                    </div>
                </div>
                <div className={`${styles.RentRollBalance}`}>
                    {item?.balance_new > 0 && <div className={`${styles.BalanceOwnd}`}>
                        <div className={`${styles.Label}`}>Balance due</div>
                        <div className={`${styles.Amount}`}>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(item?.balance_new)}</div>
                    </div>}

                    {item?.balance_new === 0 && <div className={`${styles.BalanceZero}`}>
                        <div className={`${styles.Label}`}>Cleared</div>
                        <div className={`${styles.Amount}`}>$0.00</div>
                    </div>}

                    {item?.balance_new < 0 && <div className={`${styles.BalanceZero}`}>
                        <div className={`${styles.Label}`}>Over Paid</div>
                        <div className={`${styles.Amount}`}>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(item?.balance_new)}</div>
                    </div>}

                </div>
            </div>
        </AccordionSummary>
        <AccordionDetails className={`${styles.CussAccoRow}`}>
            <div className={`${styles.RentRollExpandSec}`}>
                <div className={`${styles.DetailsSec}`}>
                    <div className={`${styles.DetailsGrid}`}>
                        <div className={`${styles.DetailsCell}`}>
                            <div className={`${styles.Label}`}>Type</div>
                            <div className={`${styles.Text}`}>One Time</div>
                        </div>
                        <div className={`${styles.DetailsCell}`}>
                            <div className={`${styles.Label}`}>Added By</div>
                            <div className={`${styles.Text}`}>{item?.added_by}</div>
                        </div>
                        <div className={`${styles.DetailsCell}`}>
                            <div className={`${styles.Label}`}>Recorded On</div>
                            <div className={`${styles.Text}`}>{dayjs(item?.created_at).format('MMM D, YYYY')}</div>
                        </div>
                        <div className={`${styles.DetailsCell}`}>
                            <div className={`${styles.Label}`}>Applied On</div>
                            <div className={`${styles.Text}`}>{dayjs(item?.date).format('MMM D, YYYY')}</div>
                        </div>
                        <div className={`${styles.DetailsCell}`}>
                            <div className={`${styles.Label}`}>Notes</div>
                            <div className={`${styles.Text}`}>{item?.description}</div>
                        </div>
                    </div>
                </div>
                <div className={`${styles.ButtonSec}`}>
                    {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("income:update") > -1 && (item?.payment_type !== "rent" && item?.payment_type !== "security-deposit" && item?.payment_type !== "late-fee") && <button className={`${styles.Button} ${styles.Blue}`} onClick={(e) => { setAddPaymentModalShow(true); setIsUpdate(true); setEditId(item?.id); }}>Edit</button>}
                    {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("income:delete") > -1 && <button className={`${styles.Button} ${styles.Red}`} onClick={(e) => { setDeleteModalShow(true); setDeleteId(item?.id); setDeleteType("payment"); }}>Delete</button>}
                    <button className={`${styles.Button} ${styles.Blue}`} onClick={(e) => resendReceipt()}>Resend Receipt</button>
                </div>
            </div>
        </AccordionDetails>
    </Accordion>);
}

export default RecordPayment;